/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Animated, Platform, StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import SVG_Svg, { G as SVG_G, GProps, Path as SVG_Path, PathProps } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
// const ForeignObject = Animated.createAnimatedComponent(SVG_ForeignObject);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="25" height="12" viewBox="0 0 25 12" fill="none"> <desc id="IMP.BLUE">{"#Icon_20_20Arrow_20Right":{"type":"SELECTOR","constraint":"none","width":25,"height":11.775397300720215},"#Vector":{"type":"SELECTOR","constraint":"none","width":25,"height":11.775397300720215},"transforms":{}}</desc>
 * <g id="Icon / Arrow Right">
 * <path id="Vector" d="M19.1176 0L18.0041 1.11363L21.9853 5.09494H0V6.66986H21.9853L18.0041 10.6618L19.1176 11.7754L25 5.88235L19.1176 0Z" fill="#373938"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Icon_20_20Arrow_20Right": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 25,
 * 		"height": 11.775397300720215
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 25,
 * 		"height": 11.775397300720215
 * 	},
 * 	"transforms": {}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  colorFill?: string;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const Icon_20_20Arrow_20Right = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  debug?: boolean;
  isInsideScrollView?: boolean;
  colorFill?: string;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    style = {
      width: 25,
      height: 12,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    colorFill = "#373938",
    svgRef,
  } = props;
  // const kRenderInstanceID = Math.random().toString().replace(".", "");
  /** Component Internal State */

  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} {...props} style={svgStyle}>
          <G id="Icon_20_20Arrow_20Right">
            <Svg preserveAspectRatio="none" viewBox="0 0 25 12">
              <Path
                id="Vector"
                d="M19.1176 0L18.0041 1.11363L21.9853 5.09494H0V6.66986H21.9853L18.0041 10.6618L19.1176 11.7754L25 5.88235L19.1176 0Z"
                fill={colorFill}
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 25 12"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Vector"
          d="M19.1176 0L18.0041 1.11363L21.9853 5.09494H0V6.66986H21.9853L18.0041 10.6618L19.1176 11.7754L25 5.88235L19.1176 0Z"
          fill={colorFill}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
    </View>
  );
};
/***/

export default React.memo(Icon_20_20Arrow_20Right);
